import App from "../containers/app/App";

export default [
    {
        path: "/",
        component: App,
    }
];



// WEBPACK FOOTER //
// ./src/routes/main.jsx